import { list } from './tags';

function endpoints(builder) {
  return {
    getCountries: builder.query({
      query: () => 'actions/tefaf/exhibitorportal/address/get-countries',
      providesTags: list,
    }),
  };
}

export { endpoints };
